import { InlinePrice } from "@/components/rates/InlinePrice";

const WD = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

const statusOf = (d) => {
  if (d.booked) return { cls: "bg-amber-100 text-amber-900", txt: d.booked };
  if (d.closed) return { cls: "bg-red-100 text-red-800", txt: "Gesperrt" };
  return { cls: "bg-emerald-50 text-emerald-800", txt: "Frei" };
};

const DayColumn = ({ d, selected, onClick, onPrice }) => {
  const dt = new Date(d.date + "T00:00:00");
  const st = statusOf(d);
  const weekend = dt.getDay() === 0 || dt.getDay() === 6;
  return (
    <div role="button" tabIndex={0} onClick={(e) => onClick(d.date, e.shiftKey)} data-testid={`rate-day-${d.date}`}
      title={`${d.rule} · Mindestaufenthalt: ${d.min_stay_rule}`}
      className={`flex flex-col w-[68px] shrink-0 border-r border-border text-center transition-colors duration-150
        ${selected ? "bg-primary/10 ring-2 ring-inset ring-primary" : weekend ? "bg-muted/40 hover:bg-muted" : "hover:bg-muted/60"}`}>
      <div className="h-12 flex flex-col justify-center border-b border-border">
        <span className="text-[10px] uppercase text-muted-foreground">{WD[dt.getDay()]}</span>
        <span className="text-sm font-semibold">{dt.getDate()}.{dt.getMonth() + 1}.</span>
      </div>
      <div className={`h-9 flex items-center justify-center text-[10px] font-medium px-1 truncate border-b border-border ${st.cls}`}>{st.txt}</div>
      <div className="h-12 flex flex-col justify-center border-b border-border">
        <InlinePrice value={d.price} bold={d.has_price_override} rule={d.rule} testid={`rate-price1-${d.date}`}
          onSave={(v) => onPrice(d.date, v === null ? { clear_price: true } : { price: v })}/>
      </div>
      <div className="h-12 flex flex-col justify-center border-b border-border">
        <InlinePrice value={d.price_long} bold={d.has_long_override} rule={d.rule_long} testid={`rate-price3-${d.date}`}
          onSave={(v) => onPrice(d.date, v === null ? { clear_price_long: true } : { price_long: v })}/>
      </div>
      <div className={`h-9 flex items-center justify-center text-sm ${d.min_stay > 1 ? "font-bold text-primary" : "text-muted-foreground"}`}>
        {d.min_stay} N.
      </div>
    </div>
  );
};

export const RateGrid = ({ days, selStart, selEnd, onDayClick, onPrice }) => {
  const inSel = (iso) => selStart && iso >= selStart && iso <= (selEnd || selStart);
  return (
    <div className="flex border border-border rounded-xl overflow-hidden bg-card" data-testid="rate-grid">
      <div className="w-[120px] shrink-0 border-r border-border text-xs text-muted-foreground bg-muted/30">
        <div className="h-12 flex items-center px-3 border-b border-border font-semibold">Datum</div>
        <div className="h-9 flex items-center px-3 border-b border-border">Verfügbarkeit</div>
        <div className="h-12 flex items-center px-3 border-b border-border">Preis 1 Nacht</div>
        <div className="h-12 flex items-center px-3 border-b border-border">Preis ab 3 Nächten</div>
        <div className="h-9 flex items-center px-3">Mindestaufenth.</div>
      </div>
      <div className="flex overflow-x-auto">
        {days.map((d) => <DayColumn key={d.date} d={d} selected={inSel(d.date)} onClick={onDayClick} onPrice={onPrice} />)}
      </div>
    </div>
  );
};
